(function ($) {

    /**
     * Add time delay to callback
     * 
     * @param {*} func Function to call after delay
     * @param {*} wait Delay in ms
     * @returns 
     */
    function debounce(func, wait) {
        let timeout;
        return function (...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), wait);
        };
    }
    /**
     * Gravity forms section
     */
    if ($('#gform_1').length > 0) {

        const defaultFranchiseeEmail = $('#input_1_22').val();

        $(document).on('gform_post_render', function (event, form_id, current_page) {

            if (1 === form_id) {

                // Set required attribute to select fields.
                $('#gform_1 select').prop('required', true);

                const defaultRegionLabel = $('#input_1_5_4_label').text();
                const defaultPostalCodeLabel = $('#input_1_5_5_label').text();

                $('#input_1_5_6').on('change', function () {
                    var selectedCountry = $(this).val();
                    if (selectedCountry === "" || country_data[selectedCountry] === undefined) {
                        $('#input_1_5_4_label').text(defaultRegionLabel);
                        $('#input_1_5_5_label').text(defaultPostalCodeLabel);
                        return;
                    }
                    let c = country_data[selectedCountry];
                    $('#input_1_5_4_label').text(c.region_label);
                    $('#input_1_5_5_label').text(c.postal_code_label);
                });
            }
        });
        gform.addAction('gform_input_change', debounce(function (elem, formId, fieldId) {
            if (formId == 1 && fieldId == 5.6 || fieldId == 5.5) {

                let country = $('#input_1_5_6').val();
                let postalCode = $('#input_1_5_5').val().replace(' ', '');
                let currentFranchiseeEmail = $('#input_1_18').val();

                let addressContainer = $('#field_1_5');

                if (country || postalCode) {
                    console.log("Country or postal code changed, validating form...", country, postalCode);
                    $.ajax({
                        url: ajaxurl,
                        method: 'POST',
                        data: {
                            action: "lookup",
                            postal_code: postalCode,
                            country_code: country,
                        },
                        success: function (response) {
                            if (response.data && response.data.email) {
                                if (defaultFranchiseeEmail != response.data.email) {

                                    // updating hidden fields
                                    $('#input_1_18').val(response.data.email);
                                    $('#input_1_16').val(response.data.country);
                                    $('#input_1_17').val(response.data.hubspotOwner);
                                    $('#input_1_14').val(response.data.name);
                                    $('#input_1_25').val(response.data.permalink);

                                }
                            }
                        }
                    }
                    );
                }


            }

        }, 10, 3), 500);

    } else {
        /**
         * Contact Form 7 section
         */
        var countryElement = document.getElementById("installorCountry");
        var zipCodeElement = document.getElementById("your-zipcode");
        var quoteForm = zipCodeElement.closest("form");

        if (zipCodeElement == null || countryElement == null) {
            console.log("L'élément zip-code n'a pas pu être retrouvé : " + countryElement.value);
        } else {
            console.log("L'élément zip-code est en place! : " + countryElement.value);
        }

        zipCodeElement.addEventListener("change", function () {

            var postalCode = zipCodeElement.value;

            var installerCountry = countryElement.value;

            // Map the installer country to its corresponding country code
            // To be removed 
            var countryCode;
            switch (installerCountry.toLowerCase()) {
                case 'canada':
                    countryCode = 'CA';
                    break;
                case 'usa':
                    countryCode = 'US';
                    break;
                case 'royaume-uni':
                case 'united kingdom':
                    countryCode = 'GB';
                    break;
                case 'france':
                    countryCode = 'FR';
                    break;
                case 'martinique':
                    countryCode = 'MQ';
                    break;
                case 'belgique':
                case 'belgium':
                    countryCode = 'BE';
                    break;
            }

            console.log("La modification du champ a été détecté : " + postalCode + "| pays : " + countryCode);

            validatePostalCodeQuoteForm(countryCode, postalCode);

        });

        /**
         * function that validate the postal Code in the form if the territory belongs to another installor
         */
        function validatePostalCodeQuoteForm(country, postalCode) {

            let theAjaxUrl = ajaxurl;

            let franchisePageEmailElement = document.getElementById("franchise-email");
            let franchisePageEmail = franchisePageEmailElement.value;

            // Élément DOM pour afficher un message si le territoire change
            let postalCodeMessageElement = document.getElementById("postalCodeTerritoryWarning");

            // Élément DOM pour afficher une erreur de saisie du code postal
            let errorPostalCode = document.getElementById("zipCodeError");

            //  Vérifie si le code postal est trop court, moins de 4 caractères
            if (postalCode.length < 4) {
                console.log("Code postal trop court :", postalCode);

                // Affiche l'erreur
                if (errorPostalCode) errorPostalCode.style.display = "block";

                // Cache le message installateur s’il est affiché avec l'erreur
                if (postalCodeMessageElement) postalCodeMessageElement.style.display = "none";

                return;
            } else {
                //  Masque l'erreur précédente quand le code est valide
                if (errorPostalCode) errorPostalCode.style.display = "none";
            }
            quoteForm.querySelector('button[type="submit"]').disabled = true;
            $.ajax({
                url: theAjaxUrl,
                method: 'POST',
                data: {
                    action: "lookup",
                    postal_code: postalCode.replace(' ', ''),
                    country_code: country,
                },
                success: function (response) {
                    if (response.data && response.data.email) {
                        let foundEmail = response.data.email;
                        console.log("Response Data:", response.data);
                        console.log("Response Data:", foundEmail);
                        if (franchisePageEmail == foundEmail) {
                            console.log("same");
                            // Masquer le message si on revient à l’installateur original
                            if (postalCodeMessageElement) {
                                postalCodeMessageElement.style.display = "none";
                            }
                        } else {
                            alertUserAndChangeFranchiseeEmail(response.data.email, response.data.name);
                            // showTerritoryModal(response.data.permalink);
                        }
                    } else {
                        console.warn("Aucun installateur trouvé pour ce code postal.");
                    }
                },
                error: function (error) {
                    console.error("Error:", error);
                    if (error.response && error.response.data) {
                        var errorMessage =
                            error.response.data.data ||
                            "An error occurred while processing your request.";
                        console.warn(errorMessage);
                    } else {
                        console.warn("An unexpected error occurred.");
                    }
                },
                complete: function () {
                    quoteForm.querySelector('button[type="submit"]').disabled = false;
                }
            }
            );
        }

        function alertUserAndChangeFranchiseeEmail(newFranchiseeEmail, newFranchiseeName) {
            let contactfranchiseeEmailElement = document.getElementById("contact-franchise-email");
            let postalCodeMessageElement = document.getElementById("postalCodeTerritoryWarning");
            let associatedFranchisee = document.getElementById("associatedFranchisee");
            let franchiseeNameElement = document.getElementById("franchisee-name"); // Nom affiché dans le message, l'id du span 

            contactfranchiseeEmailElement.value = newFranchiseeEmail;
            console.log("Email du destinataire enregistré dans franchise-email :", newFranchiseeEmail);

            associatedFranchisee.value = newFranchiseeName;

            // Mise à jour du nom de la franchise affiché dans le message
            franchiseeNameElement.textContent = newFranchiseeName;

            // Afficher le nom s'il est caché
            franchiseeNameElement.style.visibility = "visible";

            let modifiedMessage = postalCodeMessageElement.textContent;
            console.log(modifiedMessage);
            postalCodeMessageElement.style.display = "";
        }
    }

}(jQuery));